import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

export interface WishlistInactiveLoadApiAction extends Action {
    readonly start: number;
}

export const WISHLIST_INACTIVE_LOAD_API_REQUEST = "WISHLIST_INACTIVE_LOAD_API_REQUEST";

export interface WishlistInactiveLoadApiRequestAction
    extends WishlistInactiveLoadApiAction, APIRequestAction {
    readonly type: typeof WISHLIST_INACTIVE_LOAD_API_REQUEST;
}

export interface WishlistInactiveLoadNormalizedResponse extends NormalizedResponse {
    readonly result: {
        products: number[];
    };
}

export const WISHLIST_INACTIVE_LOAD_API_SUCCESS = "WISHLIST_INACTIVE_LOAD_API_SUCCESS";

export interface WishlistInactiveLoadApiSuccessAction
    extends
        WishlistInactiveLoadApiAction,
        APISuccessAction<WishlistInactiveLoadNormalizedResponse> {
    readonly type: typeof WISHLIST_INACTIVE_LOAD_API_SUCCESS;
    readonly hits: number;
}

export const WISHLIST_INACTIVE_LOAD_API_FAILURE = "WISHLIST_INACTIVE_LOAD_API_FAILURE";

export interface WishlistInactiveLoadApiFailureAction
    extends WishlistInactiveLoadApiAction, APIFailureAction {
    readonly type: typeof WISHLIST_INACTIVE_LOAD_API_FAILURE;
}

export const wishlistInactiveLoadApi = {
    request: (start: number): WishlistInactiveLoadApiRequestAction => ({
        type: WISHLIST_INACTIVE_LOAD_API_REQUEST,
        start,
    }),
    success: (
        start: number,
        hits: number,
        response: WishlistInactiveLoadNormalizedResponse,
    ): WishlistInactiveLoadApiSuccessAction => ({
        type: WISHLIST_INACTIVE_LOAD_API_SUCCESS,
        start,
        hits,
        response,
    }),
    failure: (start: number, error: string): WishlistInactiveLoadApiFailureAction => ({
        type: WISHLIST_INACTIVE_LOAD_API_FAILURE,
        start,
        error,
    }),
};

export const WISHLIST_INACTIVE_LOAD = "WISHLIST_INACTIVE_LOAD";

export interface WishlistInactiveLoadAction extends WishlistInactiveLoadApiAction {
    readonly type: typeof WISHLIST_INACTIVE_LOAD;
}

export const wishlistInactiveLoad = (start: number): WishlistInactiveLoadAction => ({
    type: WISHLIST_INACTIVE_LOAD,
    start,
});
